import React, { useEffect, useRef } from 'react';
import * as ReactDomServer from 'react-dom/server';
import { loadMap } from '../../tools/apiTools';
import { RequirementsProps } from '../../tools/context';
import OfferSlide, { getDiscountTags } from '../Carousel/OfferSlide';

export interface MapProps {
  requirements?: RequirementsProps;
  results: any[];
  geoloc?: GeolocationCoordinates;
}

const Map = (props: MapProps) => {
  const { results: initialResults, requirements } = props;
  const divRef = useRef<HTMLDivElement>();

  const results =
    initialResults?.filter((r: any) => r._geoloc?.lat && r._geoloc?.lng).filter((shop, index, arr) => {
      const identityKey =
        shop?.detailUrl ||
        (shop?.seller_id != null ? `seller:${shop.seller_id}` : null) ||
        (shop?.id != null ? `id:${shop.id}` : null) ||
        `${shop?.store_name || ''}|${shop?._geoloc?.lat}|${shop?._geoloc?.lng}`;

      return arr.findIndex((s) => {
        const sKey =
          s?.detailUrl ||
          (s?.seller_id != null ? `seller:${s.seller_id}` : null) ||
          (s?.id != null ? `id:${s.id}` : null) ||
          `${s?.store_name || ''}|${s?._geoloc?.lat}|${s?._geoloc?.lng}`;
        return sKey === identityKey;
      }) === index;
    }) || [];

  const couponQuery = props.requirements?.coupon ? `?coupon=${props.requirements.coupon}` : '';

  const detailHref = (shop: { detailUrl?: string; seller_id?: number | string }) => {
    const base = shop.detailUrl ?? `/etablissement/${shop.seller_id}`;
    if (!props.requirements?.coupon) return base;
    const sep = base.includes('?') ? '&' : '?';
    return `${base}${sep}coupon=${encodeURIComponent(props.requirements.coupon)}`;
  };

  useEffect(() => {
    loadMap(
      divRef.current,
      getCenter(),
      results.map((shop) => ({
        geoloc: shop._geoloc,
        category: shop.categslug,
        content: ReactDomServer.renderToString(
          <OfferSlide
            category={shop.categslug}
            title={shop.store_name}
            place={shop.city || shop.deptname}
            url={detailHref(shop)}
            image={shop.urlimg}
            fallbackImage={`https://tourismebyca.twic.pics/static/${props.requirements?.partner}/v2/categSearch/${shop.categslug}.jpg`}
            fallbackImage2={`https://tourismebyca.twic.pics/static/tca/v2/categSearch/${shop.categslug}.png`}
            discount={couponQuery ? [] : getDiscountTags(shop.gifts)}
            noNote
            small
            requirements={requirements}
          />
        ),
      })),
      null,
      getPosition()
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [results]);

  const getCenter = () => {
    if (props.requirements?.lon && props.requirements?.lat) {
      return { lat: -(-props.requirements.lat), lng: -(-props.requirements.lon) };
    }

    if (results.length) {
      const firstWithGeoloc = results.find((r) => r._geoloc && r._geoloc.lat && r._geoloc.lng);

      if (firstWithGeoloc) {
        return firstWithGeoloc._geoloc;
      }
    }

    return { lat: 44.838354, lng: -0.576056 };
  };

  const getPosition = () => {
    if (props.requirements?.lon && props.requirements?.lat) {
      return { lat: -(-props.requirements.lat), lng: -(-props.requirements.lon) };
    }

    if (props.geoloc?.longitude && props.geoloc?.latitude) {
      return { lat: props.geoloc.latitude, lng: props.geoloc.longitude };
    }

    return null;
  };

  return (
    <div
      className="map"
      ref={(ref) => {
        divRef.current = ref;
      }}
    />
  );
};

export default Map;
